(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('MedFrequencyFromController', MedFrequencyFromController);

    MedFrequencyFromController.$inject = ['$scope', '$state', 'MedFrequencyFrom', 'MedFrequencyFromSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function MedFrequencyFromController ($scope, $state, MedFrequencyFrom, MedFrequencyFromSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Med Frequency Froms';
        vm.entityClassHumanized = 'Med Frequency From';
        vm.entityClass = 'med-frequency-from';

        vm.medFrequencyFroms = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  MedFrequencyFrom.query(function(result) {
                  vm.medFrequencyFroms = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.medFrequencyFroms, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            MedFrequencyFrom.query(function(result) {
                vm.medFrequencyFroms = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();
